/* octagon-variant-media.js
 *
 * 1) Galerie nach gewaehlter Farbe filtern (Hauptgalerie + Zoom).
 * 2) Zoom-Ansicht: Bild komplett aufs Display rechnen und jede
 *    Anfangs-Vergroesserung des Drag-Zoom neutralisieren.
 *
 * Das Oeffnen laeuft ueber eine View Transition, die der
 * MutationObserver nicht zuverlaessig meldet - deshalb zusaetzlich
 * ein Intervall-Check, der nur laeuft solange der Dialog offen ist.
 */
(() => {
  const ZOOM = '.dialog-zoomed-gallery__dialog';
  const GALLERIES = 'media-gallery, ' + ZOOM;
  const HOLDERS = [
    'slideshow-slide',
    '.slideshow-controls__thumbnail',
    '.product-media-container',
    '.dialog-thumbnails-list__thumbnail',
  ].join(', ');

  /* ---------- 1. Farbfilter ---------- */

  const allColors = () => {
    const seen = new Set();
    document
      .querySelectorAll('input[name^="Farbe-"]')
      .forEach((i) => i.value && seen.add(i.value));
    return Array.from(seen);
  };

  const selectedColor = () => {
    const checked = document.querySelector('input[name^="Farbe-"]:checked');
    return checked ? checked.value : null;
  };

  function filterColors() {
    const galleries = document.querySelectorAll(GALLERIES);
    if (!galleries.length) return;

    const color = selectedColor();
    const colors = allColors();
    if (!color || colors.length < 2) return;

    galleries.forEach((gallery) => {
      let shown = 0;

      gallery.querySelectorAll('img').forEach((img) => {
        const holder = img.closest(HOLDERS);
        if (!holder || !gallery.contains(holder)) return;

        const alt = img.getAttribute('alt') || '';
        if (!colors.some((c) => alt.includes(c))) return;

        const match = alt.includes(color);
        holder.hidden = !match;
        holder.style.display = match ? '' : 'none';
        if (match) shown += 1;
      });

      if (shown === 0) {
        gallery.querySelectorAll(HOLDERS).forEach((el) => {
          el.hidden = false;
          el.style.display = '';
        });
      }
    });
  }

  /* ---------- 2. Zoom aufs Display rechnen ---------- */

  function force(el, prop, value) {
    if (el) el.style.setProperty(prop, value, 'important');
  }

  function unzoom(el) {
    if (!el) return;
    force(el, 'transform', 'none');
    force(el, 'scale', 'none');
    force(el, 'zoom', 'normal');
    force(el, 'min-width', '0');
    force(el, 'min-height', '0');
    force(el, 'aspect-ratio', 'auto');
    force(el, 'height', 'auto');
  }

  function fitZoom() {
    document.querySelectorAll(ZOOM).forEach((dialog) => {
      if (!dialog.open) return;

      const viewport = dialog.clientHeight || window.innerHeight;
      const thumbs = dialog.querySelector('.dialog-thumbnails-list-container');
      const thumbsHeight = thumbs ? thumbs.getBoundingClientRect().height : 0;
      const available = Math.max(200, Math.round(viewport - thumbsHeight - 40));
      const target = available + 'px';

      dialog.querySelectorAll('.dialog-zoomed-gallery > *').forEach((slide) => {
        const img = slide.querySelector('img');
        if (img && img.style.getPropertyValue('max-height') === target) return;

        const wrapper = slide.querySelector('drag-zoom-wrapper');
        const media = slide.querySelector('.product-media');

        [slide, wrapper, media].forEach((el) => {
          unzoom(el);
          force(el, 'max-height', target);
          force(el, 'max-width', '100%');
          force(el, 'overflow', 'visible');
        });

        if (wrapper) {
          // Drag-Zoom des Themes abschalten, damit das Bild nicht
          // bereits vergroessert aufgeht.
          wrapper.removeAttribute('zoom');
          wrapper.removeAttribute('data-zoom');
          force(wrapper, 'touch-action', 'auto');
        }

        if (img) {
          unzoom(img);
          force(img, 'width', 'auto');
          force(img, 'max-height', target);
          force(img, 'max-width', '100%');
          force(img, 'object-fit', 'contain');
          force(img, 'display', 'block');
          force(img, 'margin-inline', 'auto');
        }
      });
    });
  }

  /* ---------- Ablauf ---------- */

  function run() {
    filterColors();
    fitZoom();
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      run();
    });
  }

  function boot() {
    if (!document.querySelector('media-gallery')) return;

    schedule();

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (target && target.name && target.name.startsWith('Farbe-')) schedule();
    });

    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', () => setTimeout(schedule, 200));

    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
    });

    setInterval(() => {
      const dialog = document.querySelector(ZOOM);
      if (dialog && dialog.open) run();
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
